import {socketApi} from './socket-api';
import {gdSdk} from './../gd-sdk';
import {getpatternCellsCoords} from './common';
import {patternsFoundSingleton} from './patterns-found-singleton';
import {gaEvent} from '../ga-event';

let hintCode = '';

export const onPuzzleHintClickComponent = (puzzleDetail,selectedPattern,setHintCheckVisible,
    saveCellVals,cellVals,setCellVals,setLastCellInputs,rows,cols)=> async()=>{

        const placeHint = (word)=>{

            const cellValsCopy = {...cellVals};
        
            const patternCellCoords = getpatternCellsCoords(selectedPattern);
        
            patternCellCoords.forEach(({row,col},index)=> {
        
                cellValsCopy[`${row}_${col}`] = word[index];
        
            });        
            
            saveCellVals(cellValsCopy);
            setCellVals(cellValsCopy);
        
            //const {row,col} = _.last(patternCellCoords)
            setLastCellInputs(patternCellCoords);
            
        }

    const onPuzzleHintClick = async()=>{

        const puzzle = puzzleDetail.puzzle.puzzleId;
        const user = puzzleDetail.puzzleUser;;

        //console.log('onPuzzleHintClick',puzzle,user,selectedPattern);

        if(!(puzzle && user && selectedPattern)) return;

        if(patternsFoundSingleton.exists(selectedPattern)){
            console.log('already found pattern, no need for a hint!');
            return;
        }

        const {row,col,direction} = selectedPattern;
        const pattern = {row,col,direction};        

        const hintRequest = {
            user,
            puzzle,
            pattern,
            hintCode
        };

        const result = await socketApi.getHint(hintRequest);

        //console.log('get hint result after click',result);

        if(result.hintCheck){

            if(!result.hintCheck.success){
                
                hintCode = result.hintCheck.hintCode;
                try{                    

                    await gdSdk.showAdCore(true);

                    gaEvent.hint({rows,cols});
                                       
                    await onPuzzleHintClick();
                }
                catch(e){
                    console.log('error on show ad',e);
                    if(e==='The advertisement was requested too soon.'){
                        hintCode='';
                        setHintCheckVisible(false);
                        setTimeout(()=>{
                            setHintCheckVisible(true);
                        },2 * 60 * 1000);                    
                    }else{
                        await onPuzzleHintClick();
                    }
                    
                }
                

            }else{
                //console.log('HINT',result.word);

                placeHint(result.word);
                
            }            
            
        }

    };
    
    await onPuzzleHintClick();
    
    
};

